import factory from './icon';
import Svg from './Glyphs/Freight_50x50.svg';

export const Freight24x24 = factory(Svg, 24, 24);
